// Wrapper for react-datepicker that enables us to pull in its styles.

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// take advantage of `esModuleInterop` for this CommonJS module,
//   but also handle the fact that Jest runs in CommonJS mode
export default DatePicker.default || DatePicker;
